import type { SupSingleVaultV3 } from "@/types";
import React from "react";

import UiLabelPlaceholder from "@/components/Ui/Label/Placeholder";
import { formatCurrencyCompact, getVaultTvl, isEmptyAmount } from "@/utils";
import { twMerge } from "tailwind-merge";

interface UiLabelTvlProps {
  vault?: SupSingleVaultV3;
  value?: number;
  isBold?: boolean;
  variant?: "yellow" | "regular";
}

export default function UiLabelTvl({ vault, value, isBold = false, variant = "yellow" }: UiLabelTvlProps) {
  const chosenValue = vault ? getVaultTvl(vault) : value;

  // Filtering out empty values (see for the details: src/hooks/data/useMapVaults.ts)
  if (!chosenValue || isEmptyAmount(chosenValue)) {
    return <UiLabelPlaceholder variant={variant}>N/A</UiLabelPlaceholder>;
  }

  return <span className={twMerge(isBold && "font-bold", "font-sans text-[16px] font-normal leading-none tracking-normal antialiased")}>{formatCurrencyCompact(chosenValue)}</span>;
}
